import ReactivateTodayDisclaimer from './ReactivateTodayDisclaimer';

export default ReactivateTodayDisclaimer;
